import { CustomerPricing } from '@src/containers/Dealer/CustomerPricing/CustomerPricing';
import type { CustomerPricingRulesPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerPricingRulesPanel({ api, params }: LayoutPanelProps<CustomerPricingRulesPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-pricing-rules-panel"
    >
      <CustomerPricing />
    </EntityAdminPanelShell>
  );
}
